import { createAsyncAction } from '../helpers';

export const masterGetMasterAsyncAction =
	createAsyncAction('MASTER_GET_MASTER');
